module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"page.title":"ศูนย์บริการ","page.description":"แสดงและค้นหาศูนย์บริการของ Tiger Drone","button.create_company":"เพิ่มศูนย์บริการใหม่"}}')
  delete Component.options._Ctor
}
